import {ThemeConfig} from "antd";
import React from "react";
import {ModalType} from "../models/custom/enums/modalType";

export class UI {
  
  public static getTheme = (): ThemeConfig => {
    return {
      token: {
        fontFamily: 'Rubik',
        colorPrimary: '#FFB957',
      },
    };
  };
  
  public static isDesktopSize(): boolean {
    return window.innerWidth >= 992;
  }
  
  public static getModalTransform(): string {
    if (window.innerWidth >= 1600) {
      return "250px";
    } else if (window.innerWidth >= 1200) {
      return "220px";
    } else {
      return "200px";
    }
  }
  
  public static modalMaskStyle(): React.CSSProperties {
    return {background: "rgba(23, 29, 42, 0.75)", backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)"};
  }
  
  public static modalMaskStyleAreYouSure(): React.CSSProperties {
    return UI.isDesktopSize() ? {background: "rgba(23, 29, 42, 0.4)"} : this.modalMaskStyle();
  }
  
  public static isModalOnLeftSide = (modalVisibilityData: ModalType[]): boolean => {
    return modalVisibilityData.includes(ModalType.ARE_YOU_SURE) && UI.isDesktopSize();
  }
  
  public static getStyleModalOffer = (modalVisibilityData: ModalType[]): React.CSSProperties => {
    return UI.isModalOnLeftSide(modalVisibilityData) ? {top: "32px", right: UI.getModalTransform()} : {};
  }
  
  public static getStyleModalAreYouSure = (): React.CSSProperties => {
    return UI.isDesktopSize() ? {left: UI.getModalTransform()} : {};
  }
}
